<template>
  <div class="cp-set-chat-social main">
    <div class="divider" />

    <div class="row">
      <p><i class="far fa-comments icon" />Chat and Social</p>
      <div style="margin-top: 10px">
        <div
          class="field has-addons"
          v-for="c in channels"
          :key="c + z"
          style="margin-bottom: 2px"
        >
          <p class="control" style="margin-bottom: 0">
            <a
              class="button is-static is-rounded has-text-left"
              :class="{ 'has-text-danger': !c }"
              style="width: 110px"
            >
              <span> {{ capitaliseFirstLetter(c) }}</span>
            </a>
          </p>
          <p class="control is-expanded">
            <input
              class="input"
              type="text"
              v-model="obj[c]"
              placeholder="handle"
            />
          </p>
          <p
            v-if="obj[c] && obj[c].length > 4"
            class="control"
            style="margin-bottom: 0"
          >
            <a
              class="button has-text-grey"
              style="width: 30px"
              @click="channelAction(c)"
            >
              <i class="fa fa-external-link-alt fa-sm" />
            </a>
          </p>
        </div>
        <p class="hint">
          Enter your chat and social handles. For LINE you must enter LINE ID
          not phone number.
        </p>
        <p class="hint">
          Click <i class="fa fa-external-link-alt fa-sm" /> to verify the
          handle.
        </p>
        <p class="hint">
          Once you add a handle you can choose to set it as a preferred contact
          channel below.
        </p>
      </div>

      <div class="save-wrapper">
        <p v-if="updatingChannels" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveChannels">Save</p>
      </div>
    </div>

    <div class="divider" />

    <div class="row" :key="z">
      <p><i class="fa fa-users icon" />Preferred Channels</p>

      <div v-if="availableChannels.length" class="tags">
        <span
          v-for="c in availableChannels"
          :key="c"
          class="tag"
          @click="togglePreferred(c)"
          ><i
            v-if="preferredChannels.includes(c)"
            class="fa fa-star has-text-info"
            style="margin-right: 4px"
          />{{ capitaliseFirstLetter(c) }}</span
        >
        <span
          class="tag has-text-weight-medium"
          @click="addPreferredChannelInfo"
          >+</span
        >
      </div>
      <div v-else class="tag" style="margin: 10px 0 10px 22px">
        <i @click="z += 1">Please set up channels above</i>
      </div>
      <p style="margin-left: 22px">Set your preferred channels (up to 3).</p>
      <p class="hint">
        Customers will see these at the top of your business profile and may use
        them to contact you about orders.
      </p>

      <div class="save-wrapper">
        <p v-if="updatingChannels" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveChannels">Save</p>
      </div>
    </div>

    <div style="height: 60px" />
  </div>
</template>


<script>
export default {
  name: "CPSetChatSocial",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      obj: {},
      preferredChannels: [],
      updatingChannels: false,
      channels: [
        "whatsapp",
        "line",
        "messenger",
        "viber",
        "telegram",
        "facebook",
        "instagram",
      ],
      z: 0,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    availableChannels() {
      console.log(this.z, Object.keys(this.obj));
      return Object.keys(this.obj);
    },
  },
  mounted() {
    // initialise the channel data
    var channels = this.commerce.data.channels;
    if (!channels) return;
    if (Array.isArray(channels)) {
      // old format, 2d array
      channels.forEach((c) => {
        this.obj[c[0]] = c[1];
      });
    } else {
      this.obj = channels; // else already in new object format
    }
    this.deleteNullChannels();
    this.preferredChannels = this.commerce.data.preferred_channels || [];
    this.z += 1;
  },
  methods: {
    deleteNullChannels() {
      Object.keys(this.obj).forEach((k) => {
        if (!this.obj[k]) delete this.obj[k];
      });
    },
    addPreferredChannelInfo() {
      var msg = `<div style='text-align:left'>
      First add a new channel.<br>Then you can set it<br>as a preferred channel.
      </div>`;
      this.infoToast(msg, "top", 8000);
    },
    togglePreferred(c) {
      // handle removing
      if (this.preferredChannels.includes(c)) {
        this.preferredChannels.splice(c);
        return;
      }
      // otherwise adding
      if (this.preferredChannels.length >= 3) {
        var msg = `<div style='text-align:left'>
            You can only set up to<br>3 preferred channels.<br>Please remove one before<br>adding another.
            </div>`;
        this.infoToast(msg, "bottom", 6000);
        return;
      }
      if (!this.obj[c]) {
        msg = `Please enter a valid handle<br>for ${c}`;
        this.errorToast(msg);
        return;
      }
      this.preferredChannels.push(c);
    },
    channelAction(c) {
      var name = c; //c[0];
      var id = this.obj[c]; //c[1];
      var url = "";
      if (name === "instagram") url = this.instagramAction(id);
      if (name === "facebook") url = this.facebookAction(id);
      if (name === "messenger") url = this.messengerAction(id);
      if (name === "line") url = this.lineAction(id);
      if (name === "phone") url = this.phoneAction(id);
      if (name === "website") url = this.websiteAction(id);
      if (name === "form") url = this.websiteAction(id);
      if (name === "whatsapp") url = this.whatsappAction(id);
      if (name === "viber") url = this.viberAction(id);
      if (name === "orderlina") url = this.websiteAction(id);
      // previous hack for ios app  // if (this.isIOSApp()) window.location.href = url;
      setTimeout(() => {
        if (name === "phone") {
          window.location.href = `tel:${url}`;
        } else if (name === "email") {
          window.location.href = `mailto:${id}?subject=I found your shop on TUK 🦜`;
        } else window.open(url, "_blank");
      }, 250);
    },
    instagramAction(id) {
      return `https://www.instagram.com/${id}`;
    },
    facebookAction(id) {
      return `https://www.facebook.com/${id}`;
    },
    messengerAction(id) {
      return `https://m.me/${id}`;
    },
    lineAction(id) {
      // LINE @ account
      if (id[0] === "@") return `https://line.me/R/ti/p/${id}`;
      // else return `https://line.me/ti/p/${id}`; // normal LINE account, updated 16 June 2021
      else return `https://line.me/ti/p/~${id}`; // normal user, not @ account
    },
    phoneAction(id) {
      // should check if it's int'l format
      return id; // return `tel:${id}`; << already handle as tel:
    },
    websiteAction(id) {
      if (id.includes("https://")) return id; // shouldn't have this...but in case
      return `https://${id}`; // else pre-pend https
    },
    // whatsapp and viber have not been tested yet
    whatsappAction(id) {
      // sg number?
      if (id[0] === "0") id = "66" + id.slice(1); // thai number
      if (id[0] === "+") id = id.slice(1); // int'l number
      return `https://wa.me/${id}`; // int'l number without +
      //   return `https://api.whatsapp.com/send?phone=${id}`; // long url, use short
    },
    viberAction(id) {
      return `viber://chat/?number=%2B${id}`;
    },
    saveChannels() {
      this.updatingChannels = true;
      this.deleteNullChannels();
      var obj = {
        channels: this.obj,
        preferred_channels: this.preferredChannels,
      };
      this.$store
        .dispatch("updateWorkflowData", {
          id: this.commerce.id,
          data: obj,
        })
        .then((res) => {
          this.successToast("Updated channels");
          this.commerce.data = res.data.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingChannels = false));
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}

.hint {
  margin-left: 20px;
  margin-top: 8px;
  color: grey;
  font-size: 0.8em;
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.button.has-text-left {
  justify-content: flex-start;
  /* background-color: rgba(255, 255, 255, 0); */
}
.value {
  color: grey;
  margin-left: 32px;
  border-bottom: 1px dotted rgb(230, 230, 230);
}
.tags {
  margin-left: 22px;
  margin-top: 8px;
  margin-bottom: 0;
}
</style>
